module.exports = __webpack_public_path__ + "img/dr_2.8dcf2a72.png";